import React, { useState } from 'react'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import clsx from "clsx";
import "./IntlPhoneInput.scss";


interface Props {
    onChange: (value?: E164Number | undefined) => void;
    value: E164Number | undefined;
    error: string | undefined;
    onBlur: (e: React.FocusEvent<HTMLElement, Element>) => void;
    classes?: string;
    label?: string;
    placeholder?: string;
    wrapperClasses?: string;
}

type Tagged<A, T> = A & { __tag?: T };
type E164Number = Tagged<string, "E164Number">;

const IntlPhoneInput = ({ onChange, value, error, onBlur, classes, label = "Phone number", placeholder = "Eg. 0244444444", wrapperClasses }: Props) => {
    const [touched, setTouched] = useState<boolean>(false);

    return (
        <div className={wrapperClasses}>
            <div className='mb-1 text-[#374151] text-sm dark:text-text-dark-primary'>
                {label}
                <span className='text-danger-main text-sm'>*</span>
            </div>
            <PhoneInput
                className={clsx("w-full rounded !border-gray-300 dark:border-primary-dark-border_active dark:bg-primary-dark-main dark:text-text-dark-secondary", classes, { ["animate-wiggle"]: error })}
                defaultCountry="GH"
                countries={["GH"]}
                placeholder={placeholder}
                onBlur={onBlur}
                value={value}
                onChange={(value: any) => {
                    if (!touched) setTouched(true)
                    onChange(value)
                }}
                onCountryChange={(code: any) => {
                    // console.log("selected country", code);
                }}
            />
            {touched && error && <span className='mt-4 text-xs text-danger-main'>{error}</span>}
        </div>
    )
}

export default IntlPhoneInput